import { render, staticRenderFns } from "./ChangedStatus.vue?vue&type=template&id=f5382710"
import script from "./ChangedStatus.vue?vue&type=script&lang=js"
export * from "./ChangedStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports